import { create } from 'zustand'

const initialFilters = {
  queryParams: {
    elementi: 8,
    pagina: 0,
    sortBy: null,
    sortDirection: null,
  },
  body: { selettore: null },
}

export const useFilterListaPraticheStore = create(set => ({
  filters: { ...initialFilters },
  setFilters: newFilters => set({ filters: newFilters }),
  addNewFilter: newFilter =>
    set(state => ({
      filters: {
        ...state.filters,
        body: { ...state.filters.body, ...newFilter },
      },
    })),
  resetFilters: () => set({ filters: { ...initialFilters } }),
}))
